import { PropsWithChildren } from "react";
import StageHeader from "@/components/organisms/stage-header";
import AccountSidebar from "@/components/templates/Account/components/account-sidebar";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { getActionFromSlug } from "@/components/templates/Account/account-templates/render-account-view";
import { AccountRouteGuard } from "@/components/layouts/account-route-guard";
import { Locales } from "@/lib/i18n";
import { actions } from "@/locales/segment";

type AccountLayoutProps = {
  resolution: Resolution;
};

const isOrdersSlug = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions.orders === slug;
};

const isWishlistSlug = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions.wishlist === slug;
};

const AccountLayout = ({ resolution, children }: PropsWithChildren<AccountLayoutProps>) => {
  const locale = resolution?.locale;
  const isWishlistAction = getActionFromSlug(locale, resolution.slugs[0]) === "wishlist";

  return (
    <AccountRouteGuard locale={locale} route={resolution?.slugs[0]}>
      <StageHeader
        locale={locale}
        className="md:my-4"
        orientationOnMobile="left"
        title={
          isOrdersSlug(locale, resolution.slugs[0]) && resolution.slugs.length > 1
            ? __("Details of your quote", locale)
            : isWishlistSlug(locale, resolution.slugs[0])
              ? __("My favorites", locale)
              : __("My account", locale)
        }
        hideDescriptionOnMobile
        description={[
          {
            type: "paragraph",
            text: `${__("Trust Festi Rent for your parties and events.", locale)}`,
            spans: [],
          },
          {
            type: "paragraph",
            text: `${__("We are happy to advise you on choosing the equipment that will suit you perfectly.", locale)}`,
            spans: [],
          },
        ]}
      />
      <div className={cn(isWishlistAction && "bg-[#FBF9F899]")}>
        <div className="container flex flex-col gap-7.5 px-3.5 pb-7.5 md:p-7.5 lg:flex-row lg:pb-16">
          <AccountSidebar slugs={resolution.slugs} locale={resolution.locale} />
          {children}
        </div>
      </div>
    </AccountRouteGuard>
  );
};

export default AccountLayout;
